import { Form, Input } from "antd";
import { FormInstance } from "antd/lib/form";
import React, { useRef, useState } from 'react';
import { callNotify } from "../../../..";
import Footer from "../../../../components/Popup/_components/Footer";
import { UserService } from "../../../../util/services/user";
import { showErrorResponse } from "../../../../util/varibles/global";
import { IUser } from "../../../LoginPage/constants";

interface IProps {
    user: IUser

    onClose?(): void
}

const ChangePassword: React.FC<IProps> = (props) => {
    const formRef = useRef<FormInstance>(null);
    const [loading, setLoading] = useState(false)

    const handleChange = (values: any) => {
        const { username } = props.user;
        const { password } = values;
        setLoading(true)
        UserService.changePassword({ username, password })
            .then(() => {
                props.onClose?.();
                setLoading(false)
                callNotify?.success({ title: 'Success', description: 'Change password successful' })
            })
            .catch((error) => {
                showErrorResponse('Error', error)
                setLoading(false)
            })
    }


    return <Form ref={formRef} onFinish={handleChange}>
        <Form.Item
            name='password'
            rules={[{
                required: true,
                message: `"Password" is required`
            }]}
        >
            <Input.Password className="h-[36px] pl-[15px] pb-[6px] rounded-[20px] mt-3" />
        </Form.Item>
        <Footer cancel={{ click: props.onClose }} ok={{ loading }} />
    </Form>
}

export default ChangePassword;